var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ElementRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable } from 'rxjs';
import { TreeTheme } from 'src/app/shared/components/tree/tree/tree.component';
import { ViewService } from '../../view.service';
import { TreeSearchDisplayMode } from 'src/app/shared/components/tree/tree-search/tree-search.component';
import { ViewState } from '../../state/view.state';
import { ViewActions } from '../../state/view.actions';
export class ViewSearchComponent {
    constructor(viewService, store) {
        this.viewService = viewService;
        this.store = store;
        // ---------- Class Variables ----------
        this.query = '';
        this.treeTheme = TreeTheme;
        this.treeSearchDisplayMode = TreeSearchDisplayMode;
    }
    ngOnInit() {
    }
    // ---------- Interaction ----------
    handleSearchKeyup(event, value) {
        if (event.key === 'Escape') {
            this.handleExitClick();
            this.searchInput.nativeElement.blur();
        }
        this.query = value;
    }
    handleExitClick() {
        this.query = '';
        this.viewService.toggleSearch(false);
    }
    toggleDisplayMode() {
        let displayMode = this.store.selectSnapshot(ViewState.getSearchDisplayMode);
        displayMode = (displayMode === TreeSearchDisplayMode.List) ? TreeSearchDisplayMode.Tree : TreeSearchDisplayMode.List;
        this.setDisplayMode(displayMode);
    }
    setDisplayMode(displayMode) {
        this.store.dispatch(new ViewActions.SetSearchDisplayMode(displayMode));
    }
}
__decorate([
    Select(EngineState.getViewGraph),
    __metadata("design:type", Observable)
], ViewSearchComponent.prototype, "viewGraph$", void 0);
__decorate([
    Select(ViewState.getSearchDisplayMode),
    __metadata("design:type", Observable)
], ViewSearchComponent.prototype, "searchDisplayMode$", void 0);
